import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Tooltip from 'components/Tooltip';

import { Wrapper, Button, TextInput } from './styles';

class CopyButton extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showTooltip: false,
      isCopied: true,
    };

    this.showEvents = ['mouseenter', 'touchend'];
    this.hideEvents = ['mouseleave'];
    this.inputRef = createRef();
    this.defaultLabel = props.intl.formatMessage({
      id: 'copyBtn.tooltip.default',
    });
  }

  handleClick = () => {
    this.setState(
      {
        isCopied: true,
        showTooltip: true,
      },
      () => {
        this.inputRef.current.select();
        document.execCommand('copy');
      }
    );
  };

  toggleTooltip = () => {
    this.setState(({ showTooltip }) => ({
      showTooltip: !showTooltip,
      isCopied: false,
    }));
  };

  render() {
    const { showTooltip, isCopied } = this.state;
    const { textForCopy, intl, summ, currency } = this.props;

    const copiedLabel = intl.formatMessage(
      { id: 'copyBtn.tooltip.copied' },
      { summ, currency }
    );

    return (
      <Wrapper data-tooltip>
        <Button
          type="button"
          aria-label={this.defaultLabel}
          onClick={this.handleClick}
        >
          {summ}
        </Button>

        {isCopied && (
          <Tooltip
            show={showTooltip}
            position="top"
            toggle={this.toggleTooltip}
            showEvents={this.showEvents}
            hideEvents={this.hideEvents}
          >
            {isCopied ? copiedLabel : this.defaultLabel}
          </Tooltip>
        )}

        <TextInput
          ref={this.inputRef}
          type="text"
          value={textForCopy}
          readOnly
        />
      </Wrapper>
    );
  }
}

export default injectIntl(CopyButton);

CopyButton.propTypes = {
  textForCopy: PropTypes.string,
  summ: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,

  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

CopyButton.defaultProps = {
  textForCopy: '',
};
